import { createSlice } from "@reduxjs/toolkit";
import { getRecentDocumentData, getDocType, getGenDocument, getDocStorageData,saveDocumentType,getDocumnetType,deleteDocumentType} from "../actions/DocumentManagerAction";

const initialState={
    //get recent document
    loading:false,
    recDoc:null,
    error:null,
    success:false,
    //get Doc type
    loading1:false,
    docType:null,
    error1:null,
    success1:false,
    //Gen doc 
    loading2:false,
    genDoc:null,
    error2:null,
    success2:false,
    // get doc storage data 
    loading3:false,
    docStorage:null,
    error3:null,
    success3:false,
    //save document type 
    loading4:false,
    saveDocType:null,
    error4:null,
    success4:false,
    //get Document type (modal)
    loading5:false,
    documentTypes:null,
    error5:null,
    success5:false,
    ///delete doc type
    loading6:false,
    delDocType:null,
    error6:null,
    success6:false,
}

const documentManagerSlice = createSlice({
    name:"document-manager",
    initialState,
    extraReducers:(builder)=>{
        builder
        //get Recent Document 
        .addCase(getRecentDocumentData.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(getRecentDocumentData.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.recDoc=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(getRecentDocumentData.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
        // get document type 
        .addCase(getDocType.pending, (state) => {
            state.loading1 = true;
            state.error1 = null;
            state.success1 =false;
        })
        .addCase(getDocType.fulfilled, (state,{payload}) => {
            state.loading1=false;
            state.docType=payload;
            state.success1=true;
            state.error1=null;
        })
        .addCase(getDocType.rejected,(state, {paylaod})=>{
            state.loading1=false;
            state.error1=paylaod;
            state.success1=false;
        })
        // get gen document 
        .addCase(getGenDocument.pending, (state) => {
            state.loading2 = true;
            state.error2 = null;
            state.success2 =false;
        })
        .addCase(getGenDocument.fulfilled, (state,{payload}) => {
            state.loading2=false;
            state.genDoc=payload;
            state.success2=true;
            state.error2=null;
        })
        .addCase(getGenDocument.rejected,(state, {paylaod})=>{
            state.loading2=false;
            state.error2=paylaod;
            state.success2=false;
        })
        //get doc storage data 
        .addCase(getDocStorageData.pending, (state) => {
            state.loading3 = true;
            state.error3 = null;
            state.success3 =false;
        })
        .addCase(getDocStorageData.fulfilled, (state,{payload}) => {
            state.loading3=false;
            state.docStorage=payload;
            state.success3=true;
            state.error3=null;
        })
        .addCase(getDocStorageData.rejected,(state, {paylaod})=>{
            state.loading3=false;
            state.error3=paylaod;
            state.success3=false;
        })
        //save document type 
        .addCase(saveDocumentType.pending, (state) => {
            state.loading4 = true;
            state.error4 = null;
            state.success4 =false;
        })
        .addCase(saveDocumentType.fulfilled, (state,{payload}) => {
            state.loading4=false;
            state.saveDocType=payload;
            state.success4=true;
            state.error4=null;
        })
        .addCase(saveDocumentType.rejected,(state, {paylaod})=>{
            state.loading4=false;
            state.error4=paylaod;
            state.success4=false;
        })
        // get document Type (modal)
        .addCase(getDocumnetType.pending, (state) => {
            state.loading5 = true;
            state.error5 = null;
            state.success5 =false;
        })
        .addCase(getDocumnetType.fulfilled, (state,{payload}) => {
            state.loading5=false;
            state.documentTypes=payload;
            state.success5=true;
            state.error5=null;
        })
        .addCase(getDocumnetType.rejected,(state, {paylaod})=>{
            state.loading5=false;
            state.error5=paylaod;
            state.success5=false;
        })
        // delete document type 
        .addCase(deleteDocumentType.pending, (state) => {
            state.loading6 = true;
            state.error6 = null;
            state.success6 =false;
        })
        .addCase(deleteDocumentType.fulfilled, (state,{payload}) => {
            state.loading6=false;
            state.delDocType=payload;
            state.success6=true;
            state.error6=null;
        })
        .addCase(deleteDocumentType.rejected,(state, {paylaod})=>{
            state.loading6=false;
            state.error6=paylaod;
            state.success6=false;
        })
    }
});

export default documentManagerSlice.reducer;